import * as yup from 'yup';

export const societyValidationSchema = yup.object().shape({
  name: yup.string().required('El nombre es obligatorio').max(100, 'El nombre no debe exceder los 100 caracteres'),
});
